<template>
  <div class="goods-page">
    <!-- 菜单栏（内嵌App时隐藏） -->
    <app-header :title="title" :bgcolor="'#292F37'" :transparent="true" back-type="back-app" />

    <!-- VIP商品卡片 # 无限卡会员该页面，将没有卡片可展示，为空 -->
    <div class="header">
      <swiper :options="swiperOption" slidesPerView="auto" ref="mySwiper" class="swiper" v-if="goodsInfoArr.length">
        <template v-for="card in cardList">
          <swiper-slide :key="card.value">
            <!-- 每日精读训练营 -->
            <div v-if="card.key === 'activeIsCamp'" class="item xly">
              <p class="tit">每日精读训练营</p>
              <p class="price">
                <span>¥</span>
                <span class="num">{{ campArr[goodsIndex] && campArr[goodsIndex].salePrice }}</span>
                <!-- <img src="../../../images/goods/icon_sign21.png" alt=""> -->
              </p>
            </div>
            <!-- 每日精读年卡 -->
            <div v-if="card.key === 'activeIsForeignVip'" class="item nk">
              <p class="tit">每日精读年卡</p>
              <p class="price">
                <span>¥</span>
                <span class="num">{{ foreignVipArr[0] && foreignVipArr[0].salePrice }}</span>
                <!-- v-if="foreignVipArr[0] && foreignVipArr[0].hasInstallment" -->
                <!--                <img src="../../../images/goods/icon_fenqi.png" alt="">-->
              </p>
            </div>
            <!-- 无限卡会员 -->
            <div v-if="card.key === 'activeIsForeverVip'" class="item wxk">
              <p class="tit">无限卡会员</p>
              <p class="price">
                <span>¥</span>
                <span class="num">{{ foreverVipArr[0] && foreverVipArr[0].salePrice }}</span>
                <img src="../../../images/goods/icon_bcj.png" alt="" />
              </p>
            </div>
          </swiper-slide>
        </template>
      </swiper>
    </div>
    <p class="line" v-if="goodsInfo"></p>
    <!-- 无限卡内容 -->
    <vip-goods-content v-model="active" :options="{ goodsInfo, contentIndexs }" />
    <!-- 立即报名 -->
    <div class="foot">
      <div class="footer">
        <p class="price">
          <span v-if="goodsInfo" class="shop-price">¥{{ salePrice }}</span>
          <del v-if="scribingPrice" class="original-price">¥{{ scribingPrice }}</del>
        </p>
        <button class="btn" @click="onClickBuy">立即报名</button>
      </div>
    </div>
    <!-- 多商品时，先选择购买的商品 -->
    <div v-if="isShow" class="mask" @touchmove.prevent @click="isShow = false">
      <div class="wrap" @click.stop>
        <span class="closeMask" @click="isShow = false">
          <img src="../../../images/goods/close.png" alt="" />
        </span>
        <dl flex>
          <dt class="share-icon">
            <img
              :src="
                goodsInfo.shareImg || 'https://img-ylsn-test.ylyk.com/server/image/course/2025_09_19_1758277566150.png'
              "
              alt=""
            />
          </dt>
          <!-- 多商品的购买标题 -->
          <dd class="good-info">
            <p class="name" v-if="campArr.length > 1">
              {{ campArr[goodsIndex].goodsName }}
            </p>
            <p class="good-price">¥{{ salePrice }}</p>
          </dd>
        </dl>
        <div class="goods-item">
          <p
            :class="['good-name', goodsIndex === index ? 'active' : '']"
            v-for="(item, index) in goodsDetailArr"
            :key="index"
            @click="chooseGoods(index)"
          >
            <span class="name">{{ item.goodsName }} ¥{{ item.salePrice }}</span>
            <span class="fq" v-if="item.hasInstallment">
              首付¥{{ item.installList[0].downPayments }} 月供约¥{{ item.installList[0].installmentAmount }}*{{
                item.installList[0].installmentNum
              }}期
            </span>
            <span class="fq" v-else>
              <!-- 坚持学习，返学费 -->
            </span>
          </p>
        </div>
        <button class="btn btn-active" @click="payFn">立即购买</button>
      </div>
    </div>
    <!-- 订单弹幕气泡 -->
    <order-userbar :options="{ isVipForever: hasForeverVip, goodsIds: foreverVip }" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Body from '@/mixins/body'
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import { toast, appUser } from '@/utils'
import { $settingBounces } from '@/utils/common/native-api'
import OrderUserbar from '../components/order-userbar' // 无限卡购买气泡
import VipGoodsContent from './vip-goods-content'
import { saTrack } from '@/utils/common/shence'

export default {
  name: 'goods',
  components: {
    OrderUserbar,
    VipGoodsContent,
    swiper,
    swiperSlide
  },
  data() {
    return {
      title: '',
      isShow: false,
      // 定制卡片商品
      contentIndexs: {
        activeIsCamp: '0', // 训练营
        activeIsForeignVip: '1', // 年卡
        activeIsForeverVip: '2' // 无限卡
      },
      // 商品的组合标题
      goodsCardTitle: [
        ['每日外刊精读21天训练营', '每日外刊精读100天训练营'],
        [], // 无限卡占位
        ['每日精读年卡', '每日精读双年卡']
      ],
      active: '0', // tab切换索引
      // activeName: ['camp', 'foreignVip', 'foreverVip'],
      goodsIndex: 0,
      camp: [],
      foreignVip: [],
      foreverVip: [],
      goodsInfoArr: [], // 所有商品
      swiperOption: {
        spaceBetween: 16,
        onSlideChangeEnd: e => {
          console.log('e.realIndex', e.realIndex)
          this.goodsIndex = 0
          this.switchActive(e.realIndex)
        }
      }
    }
  },
  mixins: [Body],
  computed: {
    ...mapGetters('goods/vip', [
      'goodsDetail',
      'userInfo' //,
      // 'goodsInfo'
    ]),
    level() {
      return this.userInfo.level
    },
    // 训练营购买
    campArr() {
      return this.goodsInfoArr.filter(item => this.camp.indexOf(item.goodsId) !== -1)
    },
    hasCamp() {
      // level 0: 无权益
      const { level } = this
      return level === '0' && this.campArr.length > 0
    },
    // 年卡购买
    foreignVipArr() {
      return this.goodsInfoArr.filter(item => this.foreignVip.indexOf(item.goodsId) !== -1)
    },
    hasForeignVip() {
      const { level } = this
      return (level === '0' || level === '1') && this.foreignVipArr.length > 0
    },
    // 无限卡购买
    foreverVipArr() {
      return this.goodsInfoArr.filter(item => this.foreverVip.indexOf(item.goodsId) !== -1)
    },
    hasForeverVip() {
      // level 1: 畅听会员 & 每日精读会员
      // level 2: 无限卡会员
      const { level } = this
      return (level === '0' || level === '1') && this.foreverVipArr.length > 0
    },
    // 卡片的商品列表计算
    goodsDetailArr() {
      if (this.active === this.contentIndexs.activeIsCamp) {
        return this.campArr // 训练营
      }
      if (this.active === this.contentIndexs.activeIsForeignVip) {
        return this.foreignVipArr // 年卡
      }
      if (this.active === this.contentIndexs.activeIsForeverVip) {
        return this.foreverVipArr // 无限卡
      }
      return []
    },
    goodsInfo() {
      return this.goodsDetailArr[this.goodsIndex]
    },
    salePrice() {
      return this.goodsInfo.salePrice
    },
    scribingPrice() {
      const g = this.goodsInfo
      return g && g.scribingPrice
    },
    // 卡片集合
    cardList() {
      const indexs = this.contentIndexs
      const keys = Object.keys(indexs)
      const values = Object.values(indexs)
      const list = keys
        .map((key, index) => {
          return {
            key,
            value: values[index]
          }
        })
        .filter(({ key, value }) => {
          // 过滤有效的卡片
          if (
            (this.hasCamp && key === 'activeIsCamp') ||
            (this.hasForeignVip && key === 'activeIsForeignVip') ||
            (this.hasForeverVip && key === 'activeIsForeverVip')
          ) {
            return true
          }
        })
        .sort((card1, card2) => {
          return card1.value > card2.value ? 1 : -1
        })
      return list
    },
    hasGoods() {
      return this.cardList.length
    }
  },
  watch: {
    hasForeverVip(newVal) {
      if (newVal && this.level > 0) {
        // 无限卡换位置，引导购买
        this.contentIndexs.activeIsCamp = '1' // 训练营下移
        this.contentIndexs.activeIsForeignVip = '2' // 年卡下移
        this.contentIndexs.activeIsForeverVip = '0' // 无限卡第一位
        // console.log('MY_VIP> hasForeverVip', newVal)
      }
    }
  },
  created() {
    $settingBounces({
      bounces: 'disenable'
    })
    this.$store.dispatch('goods/vip/getPrivilegeLevelByUserId').then(res => {
      this.camp = res.goodsInfo.camp || []
      this.foreignVip = res.goodsInfo.foreignVip || []
      this.foreverVip = res.goodsInfo.foreverVip || []
      const goodsArr = [...this.camp, ...this.foreignVip, ...this.foreverVip]
      this.getGoodsDetail(goodsArr)
    })
  },
  methods: {
    // 创建预付订单
    preCreate({ goodsId }) {
      const userId = appUser.userId
      const preOrder = this.$store.dispatch('payment/order/preCreate', { goodsId, userId })
      preOrder.catch(({ code }) => {
        // 用户已经具备该商品权益，无需购买商品
        if (code === 30010) {
          const params = this.$route.params
          this.$router.replace({ name: 'success', params })
        }
      })
      return preOrder
    },
    switchActive(active) {
      console.log('active', active)
      if (this.cardList.length === 0) return
      active = active || 0
      const { value } = this.cardList[active]
      this.active = value
    },
    payFn() {
      const orderView = () => {
        // 无限卡检查，跳转查看协议
        const { goodsId, goodsType, equityType } = this.goodsInfo
        const isVipForever = goodsType === '50001' && equityType === 'forever'
        if (isVipForever) {
          this.$router.push({
            name: 'goods-vip-forever-protocol',
            query: { goodsId, isBuy: true }
          })
          return
        }

        this.$router.push({
          path: `/confirm-order/${goodsId}`,
          query: { paytype: 'vip' }
        })
      }
      this.preCreate(this.goodsInfo).then(orderView)
    },
    getGoodsDetail(ids) {
      this.$store
        .dispatch('goods/vip/getDetailByGoodsId', {
          goodsIds: ids
        })
        .then(res => {
          const { goodsInfoList: list } = res
          const arr = ids.map(id => list.find(e => e.goodsId === id))
          this.goodsInfoArr = arr
          // 手动切换商品文案
          this.$nextTick(() => {
            // 如果没有无限卡，调整编号; 如果训练营下架了，调整 active
            // if (this.campArr.length === 0) {
            //   this.active = '1'
            // }
            this.switchActive()
          })
        })
    },
    chooseGoods(ind) {
      this.goodsIndex = ind
    },
    onClickBuy() {
      // 当前权益下无可购买商品了（比如无限卡用户）
      if (this.goodsInfo == null) {
        toast('购买的商品无效')
        return
      }

      saTrack('me_buy_vip', {
        goods_ID: this.goodsInfo.goodsId,
        goods_name: this.goodsInfo.goodsName
      })

      // 多商品购买，需要选则
      if (this.goodsDetailArr.length > 1) {
        this.isShow = true
      } else {
        this.payFn()
      }
    }
  }
}
</script>

<style lang="less" scoped>
.goods-page {
  width: 100%;
  // background-color: #292F37;
  .header {
    width: 100%;
    background: url('../../../images/goods/bg_head.png') no-repeat;
    background-size: 100% 100%;
    background-position: center;
    .swiper {
      display: flex;
      padding: 0.64rem;
      .swiper-slide {
        transform: scaleY(0.9);
        transition: transform 0.3s;
      }
      .swiper-slide-active {
        transform: scaleY(1);
      }
      .item {
        width: 100%;
        padding: 0.48rem 0 0.64rem 0.64rem;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        font-size: 0.32rem;
        .tit {
          font-weight: bold;
        }
        .price {
          position: relative;
          margin-top: 1.34rem;
          line-height: 0.68rem;
          .num {
            font-size: 0.56rem;
            font-weight: bold;
            margin-left: 0.08rem;
          }
          img {
            position: absolute;
            top: 0;
            right: -1rem;
            width: 0.84rem;
            height: 0.32rem;
            margin-left: 0.08rem;
          }
        }
      }
      .xly {
        background: url('../../../images/goods/bg_xly.png') no-repeat;
        background-size: 100% 100%;
        background-position: center;
        color: #711a00;
        im {
          width: 0.73rem;
        }
      }
      .nk {
        background: url('../../../images/goods/bg_nk.png') no-repeat;
        background-size: 100% 100%;
        background-position: center;
        color: #8b3c10;
        .tit {
          padding-left: 0.64rem;
          padding-top: 0.05rem;
        }
      }
      .wxk {
        background: url('../../../images/goods/bg_wxk.png') no-repeat;
        background-size: 100% 100%;
        color: #ffd17f;
        .tit {
          padding-left: 0.64rem;
          padding-top: 0.05rem;
        }
      }
    }
  }
  .line {
    width: 100%;
    height: 0.02rem;
    background: linear-gradient(
      315deg,
      rgba(255, 218, 152, 0) 0%,
      rgba(255, 218, 152, 1) 49%,
      rgba(226, 161, 66, 0) 100%
    );
  }
  .foot {
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 999;
    // iphoneX only
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
    background-color: #fff;
  }
  .footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.18rem 0.47rem;
    background-color: #fff;
    .price {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      .shop-price {
        font-size: 0.44rem;
        color: #00b25a;
        font-weight: bold;
        line-height: 0.54rem;
      }
      .original-price {
        margin-top: 0.08rem;
        color: #999999;
        font-size: 0.26rem;
        line-height: 0.32rem;
      }
    }
    .btn {
      padding: 0.24rem 0.4rem;
      background-color: #00b25a;
      border-radius: 0.12rem;
      color: #fff;
    }
  }
  .mask {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.3);
    z-index: 9999;
  }
  .wrap {
    width: 100%;
    position: fixed;
    left: 0;
    bottom: 0;
    padding: 0.48rem;
    background-color: #fff;
    .closeMask {
      display: flex;
      padding: 0.16rem;
      position: absolute;
      top: 0;
      right: 0;
      img {
        width: 0.32rem;
        height: 0.32rem;
      }
    }
    .share-icon {
      width: 1.6rem;
      height: 1.6rem;
      img {
        width: 1.6rem;
        height: 1.6rem;
        border-radius: 0.04rem;
      }
    }
    .good-info {
      display: flex;
      flex-direction: column;
      margin-left: 0.24rem;
      font-size: 0.32rem;
      .name {
        line-height: 0.45rem;
      }
      .good-price {
        font-size: 0.36rem;
        font-weight: bold;
        margin-top: 0.24rem;
        color: #00b25a;
      }
    }
    .goods-item {
      margin-top: 0.72rem;
      display: flex;
      flex-direction: column;
      .good-name {
        margin-top: 0.24rem;
        padding: 0.2rem 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        color: rgba(0, 0, 0, 0.4);
        background-color: #f7f9fb;
        border-radius: 0.08rem;
        border: 1px solid #f7f9fb;
        .name {
          font-size: 0.28rem;
        }
        .fq {
          font-size: 0.2rem;
          margin-top: 0.16rem;
          opacity: 0.6;
        }
      }
      .active {
        color: #00b25a;
        background-color: #f0f7f7;
        border: 1px solid #00b25a;
      }
    }
    .btn {
      width: 100%;
      padding: 0.24rem 0;
      margin-top: 0.78rem;
      color: #fff;
      font-size: 0.32rem;
      border-radius: 0.12rem;
      background-color: #00b25a;
    }
  }

  // 测试日志
  .log {
    color: white;
    text-align: center;
    padding-top: 10px;
  }
}
</style>
